import React from "react";
import { UtilsHelper } from "utils/helpers";

function useAPIRequestKeyRef() {
  const apiRequestKeyRef = React.useRef(0);

  const updateKey = () => {
    const currentKey = UtilsHelper.getUniqueId();
    apiRequestKeyRef.current = currentKey;
    return currentKey;
  };

  return { apiRequestKeyRef, updateKey };
}

export default useAPIRequestKeyRef;
